import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {userRegister} from "../../services/userRegister";
import {langRegister} from "../../services/langRegister";
import queryString from 'query-string';
import {salesChannelRegister} from "../../services/salesChannelRegister";
import countryCodes from "country-telephone-data";
import {marketRegister} from "../../services/marketRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class Register extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoadingButton: false,
            error: false,
            dropdown: false,
            email: "",
            password: "",
            first_name: "",
            last_name: "",
            phone: "",
            countries: [],
            country: {},
        };
    };

    componentDidMount() {

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/register');
            ReactGA4.send({ hitType: "pageview", page: "/register" });
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }

    }

    componentWillMount(){
        window.scrollTo(0, 0);
        this._updateCountries();
        //document.addEventListener("keydown", this._handleKeyDown.bind(this));
    }

    componentWillUnmount() {
        //document.removeEventListener("keydown", this._handleKeyDown.bind(this));
    }

    _updateCountries() {
        let countries = JSON.parse(JSON.stringify(countryCodes.allCountries));
        for (let i = 0; i < countries.length; i++) {
            countries[i].dialCode = "+" + countries[i].dialCode;
            if (countries[i].iso2 === salesChannelRegister.get("market")) {
                this._selectCountry(countries[i]);
            }
        }
        this.setState({countries: countries});
    }

    _handleKeyDown(event){
        var ENTER_KEY = 13;
        switch( event.keyCode ) {
            case ENTER_KEY:
                this._register();
                break;
            default:
                break;
        }
    }

    _login() {
        try {
            let query = queryString.parse(this.props.location.search);
            if(query.from_path){
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login?from_path=" + query.from_path);
            }else if(query.to){
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login?from_path=" + query.to);
            }else{
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login");
            }
        } catch (e) {
            console.log(e)
        }
    }

    _register() {
        if(this.state.password !== "" && this.state.email !== ""){
            this.setState({isLoadingButton: true, error: false});
            let user = {
                email: this.state.email,
                password: this.state.password,
                name: this.state.first_name,
                surname: this.state.last_name,
                phone: this.state.country.dialCode?(this.state.country.dialCode + this.state.phone):this.state.phone
            };
            if(langRegister.lang()){
                try{
                    user.lang = langRegister.lang().toLowerCase();
                }catch (e) {}
            }
            dataRegister.signUp(salesChannelRegister.get('market'), user).then((response) => {
                if(!response.errors){
                    response.email = this.state.email;
                    userRegister.set(response);

                    //GOOGLE EVENT
                    if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                        ReactGA.event({category: 'User', action: 'Signed Up', label: 'Register'});
                        ReactGA4.event({category: 'User', action: 'Signed Up', label: 'Register'});
                    }

                    //FACEBOOK EVENT
                    if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                        ReactPixel.track('CompleteRegistration');
                    }

                    let query = queryString.parse(this.props.location.search);
                    if(query.from){
                        this.props.history.push(query.from);
                    }else if(query.from_path){
                        this.props.history.push(query.from_path);
                    }else{
                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/campaigns/running");
                    }
                }else{
                    this.setState({isLoadingButton: false, error: true});
                }
            }, (error) => {
                this.setState({isLoadingButton: false, error: true});
            });
        }else{
            this.setState({
                error: true
            });
        }
    }

    _selectCountry(option) {
        this.setState({country: option, search: option.dialCode});
    }

    _renderButton() {
        if (!this.state.isLoadingButton) {
            return (this._renderText("item_5"));
        } else {
            return (<BeatLoader size={9} color={'#ffffff'} loading={true}/>);
        }
    }


    _renderText(item) {
        return langRegister.get("register", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupOne view={"register"} props={this.props}/>
                <div className={Styles.container}>
                    <div className={Styles.title}>
                        {this._renderText("item_1")}
                    </div>
                    <div className={Styles.subtitle}>
                        {this._renderText("item_2")}
                    </div>
                    <div className={Styles.inputWrapper}>
                        <div className={Styles.inputWrapperInner}>
                            <input
                                className={
                                    cx(Styles.input, Styles.firstname)
                                }
                                placeholder={this._renderText("item_8")}
                                value={this.state.first_name}
                                onChange={(event) => this.setState({first_name: event.target.value})}
                            />
                            <input
                                className={
                                    cx(Styles.input, Styles.lastname)
                                }
                                placeholder={this._renderText("item_11")}
                                value={this.state.last_name}
                                onChange={(event) => this.setState({last_name: event.target.value})}
                            />
                        </div>
                    </div>
                    <div className={Styles.inputWrapper}>
                        <div className={Styles.inputWrapperInner}>
                            <div className={Styles.inputWrapperInnerDropDown}>
                                <input
                                    placeholder={this._renderText("item_10")}
                                    type="tel"
                                    onFocus={() => this.setState({dropdown: true})}
                                    onBlur={() => this.setState({dropdown: false})}
                                    value={this.state.search}
                                    onChange={(event) => this.setState({search: event.target.value})}
                                    className={Styles.inputWrapperInnerDropDownInput}
                                />
                                {
                                    this.state.dropdown && this.state.countries.filter((item) => {
                                        return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                    }).length > 0 &&
                                    <div className={Styles.dropdownList}>
                                        {
                                            this.state.countries.filter((item) => {
                                                return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                            }).map((prop, key) => {
                                                return (
                                                    <div key={key}
                                                         onMouseDown={() => this._selectCountry(prop)}
                                                         className={Styles.dropdownListItem}>
                                                        {prop.dialCode}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                }
                            </div>
                            <div className={Styles.inputWrapperInnerInput}>
                                <input
                                    type="tel"
                                    value={this.state.phone}
                                    onChange={(event) => this.setState({phone: event.target.value.trim()})}
                                    className={Styles.input}
                                    placeholder={this._renderText("item_9")}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={Styles.inputWrapper}>
                        <input
                            className={
                                cx(Styles.input)
                            }
                            type={"email"}
                            placeholder={this._renderText("item_3")}
                            value={this.state.email}
                            onChange={(event) => this.setState({email: event.target.value.toLowerCase()})}
                        />
                        {
                            this.state.error &&
                            <div className={Styles.inputError}/>
                        }
                    </div>
                    <div className={Styles.inputWrapper}>
                        <input
                            className={
                                cx(Styles.inputPassword)
                            }
                            type={"password"}
                            placeholder={this._renderText("item_4")}
                            value={this.state.password}
                            onChange={(event) => this.setState({password: event.target.value})}
                        />
                        {
                            this.state.error &&
                            <div className={Styles.inputError}/>
                        }
                    </div>
                    <div onClick={() => this._register()} className={Styles.button}>
                        {this._renderButton()}
                    </div>
                    <div className={Styles.text}>
                        {this._renderText("item_6")}<span onClick={() => this._login()}
                                                          className={Styles.textBold}>{this._renderText("item_7")}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default Register;


// WEBPACK FOOTER //
// ./src/pages/register/component.js